<script setup lang="ts">
  import { inject } from 'vue';
  import DataNotFound from '~/components/Base/DataNotFound.vue';
  import DataNotLoaded from '~/components/Base/DataNotLoaded.vue';

  const isLoading = inject('isLoading');

  interface Props {
    errorOccured: boolean;
    data: any[] | undefined;
    serialnumber: string;
  }

  const { errorOccured = false, data, serialnumber } = defineProps<Props>();
</script>

<template>
  <div :class="$gStyle('gap-[10px] flex flex-col')">
    <!-- Table -->
    <div>
      <div
        class="grid grid-cols-12 gap-[32px]"
        v-if="
          isLoading && !errorOccured && data !== undefined && data.length === 0
        "
      >
        <div
          class="bg-white grid h-48 place-content-center col-span-12 m-0 p-0"
        >
          <patternlib-spinner size="lg" :spin="true"></patternlib-spinner>
        </div>
      </div>
      <!-- Error Page -->
      <DataNotLoaded v-else-if="errorOccured" />
      <!-- No Page -->
      <div v-else-if="data === undefined"></div>
      <!-- No Data Found Page -->
      <DataNotFound
        v-else-if="
          !isLoading && !errorOccured && data !== undefined && data?.length == 0
        "
        :serialnumber="serialnumber"
      />
      <!-- Custom Input -->
      <div v-else>
        <!-- Custom Table related Text -->
        <div :class="$gStyle('my-7')">
          <slot name="custom-table-header"></slot>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
